import React, { FC, useEffect } from "react";

import { EVENTS, gtmEcommercePusher, isLvEnvironment } from "@modules/gtm";
import gtmEventEcommerceData from "@modules/gtm/gtmEventEcommerceData";
import mapOrderSuccessValuesToGTMValues from "@modules/gtm/mapOrderSuccessValuesToGTMValues";

import { TPaymentStatus } from "../../types";

type TPurchaseGTMEventProps = {
  paymentStatus: TPaymentStatus;
};

const PurchaseGTMEvent: FC<TPurchaseGTMEventProps> = ({ paymentStatus }) => {
  useEffect(() => {
    if (isLvEnvironment()) {
      return;
    }
    gtmEcommercePusher(
      gtmEventEcommerceData(mapOrderSuccessValuesToGTMValues(paymentStatus), undefined, EVENTS.PURCHASE)
    );
  }, [paymentStatus]);

  return <></>;
};
export default PurchaseGTMEvent;
